module.exports = __webpack_public_path__ + "static/img/lenovoTabM8.ad706dfa.png";